import { createActionTypeReducer } from 'util/reducers'
import { FETCH_TAGS_SUCCESS } from '../actionTypes'

const totalCountInitialState = null

const reducers = {}

// We only want to update the tags totalCount in state if we're loading tags
// for a completely unflitered state.
reducers[FETCH_TAGS_SUCCESS] = (
  draftState,
  {
    payload: { tags: { totalCount } = {} } = {},
    request: { parameters = {} } = {},
  }
) => {
  if (totalCount === undefined || parameters?.filter?.search) return draftState

  return totalCount
}

export default createActionTypeReducer(reducers, totalCountInitialState)
